export default "__VITE_ASSET__DDx8wKow__"